import { render } from "./Contact.vue?vue&type=template&id=3e66710c&scoped=true&bindings={}"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=3e66710c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3e66710c"

export default script